import React, {useState, useEffect} from "react";

import {
    Box,
    Button,
    IconButton,
    InputAdornment,
    LinearProgress,
    TextField,
    Theme,
    Typography,
} from "@mui/material";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import {FormattedMessage} from "react-intl";
import {useDispatch, useSelector} from "react-redux";
import {ContainerClasses} from '../../themes/containerClasses'
import {MFAChallengeDialog} from './MFAChallengeDialog';
import {MFARegisterDialog} from './MFARegisterDialog';
import {PWDChangeDialog} from './PWDChangeDialog';
import {useNavigate, useParams} from "react-router-dom";
import {useAuth} from "../../hooks/useAuth";
import {useSnackbar} from "notistack";

export function AuthenticationScreen() {

  const dispatch = useDispatch<any>();
  const styles = ContainerClasses();

  const [password, setPassword] = useState<string>("");
  const [username, setUsername] = useState<string>("");

  const [showPassword, setShowPassword] = useState<boolean>(false);

  const {accessToken, mfaRegister, mfaChallenge, error, onLogin, isLoading} = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  const onLoginButtonClick = () => {
    if(password){
      onLogin(username, password);
    }
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    onLoginButtonClick();
  }

  useEffect(() => {
    if(error.errorLogin !== ""){
         enqueueSnackbar(error.errorLogin, {
          variant: "error",
        });
      }
  }, [error]);


  return (

  <>
     <MFAChallengeDialog
        username={username}
        password={password}
     />

     <MFARegisterDialog
        username={username}
        password={password}
     />

     <PWDChangeDialog
        username={username}
        password={password}
     />

     <Box sx={{display: "flex",
               flexDirection: "column",
               overflow: "auto",
               position: "fixed",
               top: 0,
               bottom: 0,
               left: 0,
               right: 0,
               alignItems: "center",
               justifyContent: "center"}}>


       <Box>
         {isLoading && <LinearProgress color="primary" />}

         <Box sx={{mt: '4pt',
                   mb: '4pt'}}>
           <Typography
               color="textSecondary"
               align="center"
             >
               Please provide your username and password
             </Typography>
          </Box>

        <form onSubmit={handleSubmit}>

           <Box sx={{mt: '4pt',
                     mb: '4pt'}}>

               <TextField
                 size="small"
                 label="Username"
                 variant="filled"
                 fullWidth
                 type={"text"}
                 InputProps={{
                   disableUnderline: true,
                 }}
                 value={username}
                 onChange={(event) => setUsername(event.target.value)}
               />
            </Box>

           <Box sx={{mt: '4pt',
                     mb: '4pt'}}>

               <TextField
                 size="small"
                 label="Password"
                 variant="filled"
                 fullWidth
                 type={showPassword ? "text" : "password"}
                 InputProps={{
                   disableUnderline: true,
                   endAdornment: (
                       <InputAdornment position="end">
                           <IconButton size="small" onClick={() => setShowPassword(!showPassword)}>
                               {showPassword &&
                                   <VisibilityRoundedIcon/>
                               }
                               {!showPassword &&
                                   <VisibilityOffRoundedIcon/>
                               }
                           </IconButton>
                       </InputAdornment>
                   ),
                 }}
                 value={password}
                 onChange={(event) => setPassword(event.target.value)}
               />
            </Box>

           <Box sx={{mt: '4pt',
                     mb: '4pt'}}>
            <Button
              fullWidth
              disabled={username === "" ? true : password === "" ? true : false}
              color="primary"
              size="small"
              variant="contained"
              type="submit"
            >
              <FormattedMessage id="login" defaultMessage="Login" />
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  </>
  );
}
